import React from 'react'

import { SuccessButtonComponent } from './styles'

const SuccessButton = props => {
    return <SuccessButtonComponent {...props} />
}

export { SuccessButton }
